export default __webpack_public_path__ + "static/media/coin.5cdcae18.svg";